import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, toDisplayString as _toDisplayString, renderList as _renderList, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  "data-cy": "action-modal",
  class: "relative flex flex-col select-none max-w-sm"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row pt-6 pb-4 pr-6"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_4 = { class: "mb-4 text-xl font-semibold text-center text-gray-900" }
const _hoisted_5 = {
  key: 0,
  class: "mb-8 text-center text-gray-500 whitespace-pre-line"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_IconGlyph = _resolveComponent("IconGlyph")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    danger: _ctx.danger,
    onClose: _ctx.close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.showClose)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, [
                _createVNode(_component_BaseIcon, {
                  class: "text-gray-400",
                  name: "close"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col items-center px-10 pb-10", { 'pt-16': !_ctx.showClose }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["mb-5", _ctx.iconBgClasses])
          }, [
            (_ctx.icon)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.isGlyph)
                    ? (_openBlock(), _createBlock(_component_IconGlyph, {
                        key: 0,
                        name: _ctx.icon,
                        color: _ctx.iconColor,
                        size: "large"
                      }, null, 8, ["name", "color"]))
                    : (_openBlock(), _createBlock(_component_BaseIcon, {
                        key: 1,
                        class: _normalizeClass(["text-5xl", 'text-' + _ctx.iconColor]),
                        name: _ctx.icon,
                        height: "32px",
                        stroke: _ctx.stroke
                      }, null, 8, ["class", "name", "stroke"]))
                ], 64))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
          (_ctx.body.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.body), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action, index) => {
            return (_openBlock(), _createBlock(_component_BaseButton, {
              key: action.label,
              class: _normalizeClass({ 'mb-3': index < _ctx.actions.length - 1 }),
              block: "",
              size: "large",
              "data-dusk": `${action.label.toLowerCase().split(' ').join('-')}-btn`,
              color: action.color,
              onClick: ($event: any) => (_ctx.onActionClick(action, $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(action.label), 1)
              ]),
              _: 2
            }, 1032, ["class", "data-dusk", "color", "onClick"]))
          }), 128))
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["danger", "onClose"]))
}